import apiClient from "@/services/apiClient.js";

export async function getSipAddress(number) {
  const response = await apiClient.get(
    `api/GetMagratheaDataFunction/${number}`
  );
  return response.data;
}
